import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["fontSize", "className", "style", "children", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgIcon = function SvgIcon(_ref) {
  var _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? 'medium' : _ref$fontSize,
    className = _ref.className,
    style = _ref.style,
    children = _ref.children,
    size = _ref.size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var sizeMap = {
    small: '20px',
    medium: '24px',
    large: '32px',
    inherit: 'inherit'
  };
  var iconSize = size || sizeMap[fontSize];
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    className: className,
    style: _objectSpread({
      width: iconSize,
      height: iconSize,
      fill: 'currentColor'
    }, style),
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, otherProps), {}, {
    children: children
  }));
};
export default SvgIcon;